import React, { FC } from "react"
import { StyleSheet, TouchableOpacity, TouchableOpacityProps } from "react-native"
import { palette } from "../../theme"

const PressableContainer: FC<TouchableOpacityProps> = (props) => {
  const styles = StyleSheet.flatten([defaultStyles.root, props.style])

  return (
    <TouchableOpacity {...props} style={styles}>
      {props.children}
    </TouchableOpacity>
  )
}

// Styles
const defaultStyles = StyleSheet.create({
  root: {
    backgroundColor: palette.lightGrey1,
    borderRadius: 10,
  },
})

export default PressableContainer
